"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _momentRange = require("moment-range");
var _constants = _interopRequireDefault(require("./constants"));
(0, _momentRange.extendMoment)(_momentTimezone.default);
var _guessTimezone = function guessTimezone() {
  return _momentTimezone.default.tz.guess(_constants.default.IgnoreCachedTimezone);
};
var DateUtil = {
  createListOfHours: function createListOfHours(startHour, endHour, timezone) {
    var step = _constants.default.TimeConstraint.minutes.step;
    // 1 AM
    var startTime = _momentTimezone.default.tz(timezone).startOf('day').add(1, 'hours');
    var endTime = _momentTimezone.default.tz(timezone).endOf('day').add(step, 'minutes');
    var result = [];
    startTime = startHour ? startTime.hour(startHour.hour()).minute(startHour.minute()) : startTime;
    if (endHour) {
      endTime = _momentTimezone.default.tz(timezone).hour(endHour.hour()).minute(endHour.minute()).add(step, 'minutes');
    }
    do {
      result.push({
        label: startTime.format(_constants.default.DateTimeFormat.shortTimeAMPM),
        value: startTime.format(_constants.default.DateTimeFormat.shortTimeAMPM),
        dateValue: (0, _momentTimezone.default)(startTime)
      });
      startTime.add(step, 'minutes');
    } while (startTime.isBefore(endTime, 'minutes'));
    return result;
  },
  getDayOfWeek: function getDayOfWeek(time) {
    return (0, _momentTimezone.default)(time).format(_constants.default.DateTimeFormat.dayOfWeek);
  },
  utc: function utc(date) {
    return _momentTimezone.default.utc(date);
  },
  changeTimezone: function changeTimezone(date) {
    var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _guessTimezone();
    return (0, _momentTimezone.default)(date).utcOffset((0, _momentTimezone.default)(date).tz(timezone).utcOffset(), true);
  },
  format: function format(date, _format) {
    return (0, _momentTimezone.default)(date).format(_format);
  },
  formatUTC: function formatUTC(date, format, timezone) {
    return _momentTimezone.default.utc(date).tz(timezone).format(format);
  },
  getDateInTimezone: function getDateInTimezone(date) {
    var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _guessTimezone();
    return (0, _momentTimezone.default)(date).tz(timezone);
  },
  getDateInTimezoneTimestamp: function getDateInTimezoneTimestamp(timestamp) {
    var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _guessTimezone();
    var browserOffset = -1 * new Date().getTimezoneOffset();
    var result = (0, _momentTimezone.default)(timestamp * 1000).tz(timezone);
    // adding moment's offsets takes you back to UTC, so we add the utcOffset
    // of the input and subtract the offset of the browser to render the time
    // for the browser.
    result.add(result.utcOffset() - browserOffset, 'minutes');
    return result.toDate();
  },
  getDateInTimezoneToDate: function getDateInTimezoneToDate(date) {
    var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _guessTimezone();
    var browserOffset = -1 * new Date().getTimezoneOffset();
    var result = (0, _momentTimezone.default)(date).tz(timezone);
    // adding moment's offsets takes you back to UTC, so we add the utcOffset
    // of the input and subtract the offset of the browser to render the time
    // for the browser.
    result.add(result.utcOffset() - browserOffset, 'minutes');
    return result.toDate();
  },
  getTimestampInSecond: function getTimestampInSecond(value) {
    return (0, _momentTimezone.default)(value).unix();
  },
  convertTimestampIntoDate: function convertTimestampIntoDate(value) {
    return new Date(value * 1000);
  },
  guessTimezone: function guessTimezone() {
    return _guessTimezone();
  },
  isOverlaps: function isOverlaps(range1, range2) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var newRange1 = range1;
    var newRange2 = range2;
    if (options.timeOnly) {
      var timezone = _lodash.default.get(options, 'timezone', _guessTimezone());
      var currentDate = DateUtil.getDateInTimezone(new Date(), timezone);
      var convertTime = function convertTime(range) {
        var r = DateUtil.getDateInTimezone(range, timezone);
        return (0, _momentTimezone.default)(currentDate).hour(r.hour()).minute(r.minute()).second(0);
      };
      newRange1 = _lodash.default.map(range1, convertTime);
      newRange2 = _lodash.default.map(range2, convertTime);
    }
    newRange1 = _momentTimezone.default.range(newRange1);
    newRange2 = _momentTimezone.default.range(newRange2);
    return newRange1.overlaps(newRange2);
  },
  isRangeSame: function isRangeSame(range1, range2) {
    var newRange1 = _momentTimezone.default.range(range1);
    var newRange2 = _momentTimezone.default.range(range2);
    return newRange1.isSame(newRange2);
  }
};
var _default = DateUtil;
exports.default = _default;